<section class="space-y-2">
  <h1 class="text-xl font-semibold">{{ i18n.translate('settings.title') }}</h1>
  <p class="text-sm text-slate-600 dark:text-slate-400">
    {{ i18n.translate('settings.description') }}
  </p>
</section>
